import { Loader } from "@mantine/core";
import classnames from "classnames";

import styles from "./page-footer.module.scss";

type ButtonAction = {
  onClick: () => void;
  type?: "button";
  label: string;
  theme?: "primary" | "secondary";
  disabled?: boolean;
  form?: string;
};

type SubmitAction = {
  onClick?: () => void;
  type: "submit";
  label: string;
  theme?: "primary" | "secondary";
  disabled?: boolean;
  form?: string;
};

export type FooterAction = ButtonAction | SubmitAction;

type PageFooterProps = {
  loading?: boolean;
  actions?: FooterAction | FooterAction[];
};

const PageFooter = ({ loading, actions }: PageFooterProps) => {
  if (!actions) {
    return null;
  }

  if (loading) {
    return (
      <div className={styles.footer}>
        <div className={styles.buttonContainer}>
          <div className={styles.footerButton}>
            <span>{"Loading"}</span>
            <Loader className={styles.footerSpinner} size={24} />
          </div>
        </div>
      </div>
    );
  }

  const buttonActions = Array.isArray(actions) ? actions : [actions];

  return (
    <div className={styles.footer}>
      <div className={styles.buttonContainer}>
        {buttonActions.map((action) => (
          <button
            className={classnames(styles.footerButton, {
              [styles.footerButtonPrimary]:
                action.theme === "primary" || !action.theme,
              [styles.footerButtonSecondary]: action.theme === "secondary",
            })}
            onClick={action.onClick}
            type={action.type === "submit" ? "submit" : "button"}
            key={action.label}
            disabled={action.disabled}
            form={action.form}
          >
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PageFooter;
